import { PickersDay } from "@mui/x-date-pickers/PickersDay";

export function CustomDay(props) {
	const { day, eventsData = {}, ...other } = props;
	const dateKey = day.format("YYYY-MM-DD");
	const events = eventsData[dateKey] || [];
	const holidayColor = events.length > 0 ? events[0].color : null;

	return (
		<PickersDay
			{...other}
			day={day}
			disableMargin
			sx={{
				...(holidayColor && {
					backgroundColor: holidayColor + " !important",
					color: "#fff !important",
					borderRadius: "50% !important",
					"&:hover": {
						backgroundColor: holidayColor + " !important",
						opacity: 0.9,
					},
				}),
			}}
		/>
	);
}
